import { TEMPLATE_CATEGORIES, TEMPLATE_CATEGORY_DESIGNS } from '@/router/route-types';
import TemplatesBlocks from '@/views/Templates/TemplatesBlocks.vue';

const Empty = {
  template: `<router-view />`
};

export default {
  path: 'templates-blocks',
  component: Empty,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: TemplatesBlocks,
      meta: { auth: true },
      children: [
        {
          path: '',
          name: TEMPLATE_CATEGORIES,
          component: () => import(/* webpackChunkName: "templates" */ '@/views/Templates/DesignCategories.vue'),
          meta: { auth: true }
        },
        {
          path: 'categories/:id',
          name: TEMPLATE_CATEGORY_DESIGNS,
          component: () => import(/* webpackChunkName: "templates" */ '@/views/Templates/DesignsPerCategory.vue'),
          meta: { auth: true }
        }
      ]
    }
  ]
};
